import { TextAtlas } from "./TextAtlas";
import { TextTexture } from "./TextTexture";
import { Point } from "../../maths/Point";
import { RenderInfo } from "../../renders/RenderInfo";
import { FontInfo } from "../../utils/FontInfo";
import { WordText } from "../../utils/WordText";
import { CharRenderInfo } from "./CharRenderInfo";
import { CharRender_Canvas } from "./CharRender_Canvas";
import { ILaya } from "../../../ILaya";
import { Const } from "../../Const";
import { EventDispatcher } from "../../events/EventDispatcher";
export class TextRender extends EventDispatcher {
    constructor() {
        super();
        this.fontSizeInfo = {};
        this.mapFont = {};
        this.fontID = 0;
        this.fontScaleX = 1.0;
        this.fontScaleY = 1.0;
        this._curStrPos = 0;
        this.textAtlases = [];
        this.isoTextures = [];
        this.lastFont = null;
        this.fontSizeW = 0;
        this.fontSizeH = 0;
        this.fontSizeOffX = 0;
        this.fontSizeOffY = 0;
        this.renderPerChar = true;
        this._fontMeasure = null;
        var bugIOS = false;
        var miniadp = ILaya.Laya['MiniAdpter'];
        if (miniadp && miniadp.systemInfo && miniadp.systemInfo.system) {
            bugIOS = miniadp.systemInfo.system.toLowerCase() === 'ios 10.1.1';
        }
        if ((ILaya.Browser.onMiniGame ||
            ILaya.Browser.onTTMiniGame ||
            ILaya.Browser.onBLMiniGame ||
            ILaya.Browser.onAlipayMiniGame ||
            ILaya.Browser.onTBMiniGame) &&
            !bugIOS)
            TextRender.isWan1Wan = true;
        this.charRender = new CharRender_Canvas(2048, 2048, TextRender.scaleFontWithCtx, !TextRender.isWan1Wan, false);
        TextRender.textRenderInst = this;
        ILaya.Laya['textRender'] = this;
    }
    set fontMeasure(m) {
        this._fontMeasure = m;
    }
    get fontMeasure() {
        return this._fontMeasure;
    }
    _wan1wansz(font, size) {
        let fontstr = 'bold ' + size + 'px ' + font;
        let fontSizeW = this.charRender.getWidth(fontstr, '有') * 1.5;
        let fontSizeH = size * 1.5;
        var szinfo = fontSizeW << 8 | fontSizeH;
        this.fontSizeInfo[font] = szinfo;
        return szinfo;
    }
    getFontSizeInfo(font) {
        var finfo = this.fontSizeInfo[font];
        if (!finfo) {
            if (TextRender.isWan1Wan) {
                finfo = this._wan1wansz(font, TextRender.standardFontSize);
            }
            else {
                finfo = this._fontMeasure.getFontSizeInfo(font, TextRender.standardFontSize);
            }
            this.fontSizeInfo[font] = finfo;
        }
        return finfo;
    }
    setFont(font) {
        if (this.lastFont == font)
            return;
        this.lastFont = font;
        var fontsz = this.getFontSizeInfo(font._family);
        var offx = fontsz >> 24;
        var offy = (fontsz >> 16) & 0xff;
        var fw = (fontsz >> 8) & 0xff;
        var fh = fontsz & 0xff;
        var k = font._size / TextRender.standardFontSize;
        this.fontSizeOffX = Math.ceil(offx * k);
        this.fontSizeOffY = Math.ceil(offy * k);
        this.fontSizeW = Math.ceil(fw * k);
        this.fontSizeH = Math.ceil(fh * k);
        if (font._font.indexOf('italic') >= 0) {
            this.fontStr = font._font.replace('italic', '');
        }
        else {
            this.fontStr = font._font;
        }
    }
    getNextChar(str) {
        var len = str.length;
        var start = this._curStrPos;
        if (!str.substring)
            return null;
        if (start >= len)
            return null;
        var i = start;
        var state = 0;
        for (; i < len; i++) {
            var c = str.charCodeAt(i);
            if ((c >>> 11) == 0x1b) {
                if (state == 1)
                    break;
                state = 1;
                i++;
            }
            else if (c === 0xfe0e || c === 0xfe0f) {
            }
            else if (c == 0x200d) {
                state = 2;
            }
            else {
                if (state == 0)
                    state = 1;
                else if (state == 1)
                    break;
                else if (state == 2) {
                }
            }
        }
        this._curStrPos = i;
        return str.substring(start, i);
    }
    filltext(ctx, data, x, y, fontStr, color, strokeColor, lineWidth, textAlign) {
        if (data.length <= 0)
            return;
        var font = FontInfo.parse(fontStr);
        var nTextAlign = 0;
        switch (textAlign) {
            case 'center':
                nTextAlign = Const.ENUM_TEXTALIGN_CENTER;
                break;
            case 'right':
                nTextAlign = Const.ENUM_TEXTALIGN_RIGHT;
                break;
        }
        this._fast_filltext(ctx, data, x, y, font, color, strokeColor, lineWidth, nTextAlign);
    }
    _fast_filltext(ctx, data, x, y, font, color, strokeColor, lineWidth, textAlign) {
        if (data && !(data.length >= 1))
            return;
        if (lineWidth < 0)
            lineWidth = 0;
        this.setFont(font);
        this.fontScaleX = this.fontScaleY = 1.0;
        if (TextRender.scaleFontWithCtx) {
            let sx = ctx.getMatScaleX();
            let sy = ctx.getMatScaleY();
            if (sx < 1e-4 || sy < 1e-1)
                return;
            if (sx > 1)
                this.fontScaleX = Math.min(TextRender.maxFontScale, sx);
            if (sy > 1)
                this.fontScaleY = Math.min(TextRender.maxFontScale, sy);
        }
        font._italic && (ctx._italicDeg = 13);
        let wt = data;
        let isWT = data instanceof WordText;
        let str = data && data.toString();
        let sameTexData = isWT ? wt.pageChars : [];
        let strWidth = 0;
        if (isWT) {
            str = wt.text;
            strWidth = wt.width;
            if (strWidth < 0) {
                strWidth = wt.width = this.charRender.getWidth(this.fontStr, str);
            }
        }
        else {
            strWidth = str ? this.charRender.getWidth(this.fontStr, str) : 0;
        }
        switch (textAlign) {
            case Const.ENUM_TEXTALIGN_CENTER:
                x -= strWidth / 2;
                break;
            case Const.ENUM_TEXTALIGN_RIGHT:
                x -= strWidth;
                break;
        }
        if (isWT) {
            if (this.hasFreedText(sameTexData) || wt.pagecharsCtx != ctx) {
                sameTexData = wt.pageChars = [];
            }
        }
        let splitTex = this.renderPerChar = (!isWT) || TextRender.forceSplitRender || (isWT && wt.splitRender);
        if (!sameTexData || sameTexData.length < 1) {
            if (isWT) {
                wt.scalex = this.fontScaleX;
                wt.scaley = this.fontScaleY;
            }
            if (splitTex) {
                let stx = 0;
                let sty = 0;
                this._curStrPos = 0;
                let curstr;
                while (true) {
                    curstr = this.getNextChar(str);
                    if (!curstr)
                        break;
                    let ri = this.getCharRenderInfo(curstr, font, color, strokeColor, lineWidth, false);
                    if (!ri) {
                        break;
                    }
                    if (ri.isSpace) {
                    }
                    else {
                        var add = sameTexData[ri.texture.id];
                        if (!add) {
                            var o1 = { texgen: ri.texture.genID, tex: ri.texture, words: new Array() };
                            sameTexData[ri.texture.id] = o1;
                            add = o1.words;
                        }
                        else {
                            add = add.words;
                        }
                        add.push({ ri: ri, x: stx, y: sty, w: ri.bmpWidth / this.fontScaleX, h: ri.bmpHeight / this.fontScaleY });
                        stx += ri.width;
                    }
                }
            }
            else {
                let margin = (font._size / 3 | 0);
                let isotex = TextRender.noAtlas || (strWidth + margin + margin) * this.fontScaleX > TextRender.atlasWidth;
                let ri = this.getCharRenderInfo(str, font, color, strokeColor, lineWidth, isotex);
                sameTexData[0] = { texgen: ri.texture.genID, tex: ri.texture, words: [{ ri: ri, x: 0, y: 0, w: ri.bmpWidth / this.fontScaleX, h: ri.bmpHeight / this.fontScaleY }] };
            }
            isWT && (wt.pagecharsCtx = ctx);
        }
        this._drawResortedWords(ctx, x, y, sameTexData);
        ctx._italicDeg = 0;
    }
    _drawResortedWords(ctx, startx, starty, samePagesData) {
        var isLastRender = ctx._charSubmitCache ? ctx._charSubmitCache._enable : false;
        var mat = ctx._curMat;
        for (var id in samePagesData) {
            var dt = samePagesData[id];
            if (!dt)
                continue;
            var pri = dt.words;
            var count = pri.length;
            if (count <= 0)
                continue;
            var tex = samePagesData[id].tex;
            for (var j = 0; j < count; j++) {
                var riSaved = pri[j];
                var ri = riSaved.ri;
                if (ri.isSpace)
                    continue;
                ctx.touchRes(ri);
                ctx.drawTexAlign = true;
                ctx._inner_drawTexture(tex, tex.id, startx + riSaved.x - ri.orix, starty + riSaved.y - ri.oriy, riSaved.w, riSaved.h, mat, ri.uv, 1.0, isLastRender, 0xffffffff);
            }
        }
    }
    hasFreedText(txts) {
        for (let i in txts) {
            var pri = txts[i];
            if (!pri)
                continue;
            var tex = pri.tex;
            if (tex.destroyed || tex.genID != pri.texgen) {
                return true;
            }
        }
        return false;
    }
    getCharRenderInfo(str, font, color, strokeColor, lineWidth, isoTexture = false) {
        var fid = this.mapFont[font._family];
        if (fid == undefined) {
            this.mapFont[font._family] = fid = this.fontID++;
        }
        var key = str + '_' + fid + '_' + font._size + '_' + color;
        if (lineWidth > 0)
            key += '_' + strokeColor + lineWidth;
        if (font._bold)
            key += 'P';
        if (this.fontScaleX != 1 || this.fontScaleY != 1) {
            key += (this.fontScaleX * 20 | 0) + '_' + (this.fontScaleY * 20 | 0);
        }
        var i = 0;
        var sz = this.textAtlases.length;
        var ri;
        var atlas;
        if (!isoTexture) {
            for (i = 0; i < sz; i++) {
                atlas = this.textAtlases[i];
                ri = atlas.charMaps[key];
                if (ri) {
                    ri.touch();
                    return ri;
                }
            }
        }
        ri = new CharRenderInfo();
        this.charRender.scale(this.fontScaleX, this.fontScaleY);
        ri.char = str;
        ri.height = font._size;
        var margin = (font._size / 3 | 0);
        var imgdt = null;
        if (!lineWidth) {
            lineWidth = 0;
        }
        var w1 = Math.ceil((this.charRender.getWidth(this.fontStr, str) + 2 * lineWidth) * this.fontScaleX);
        let needCanvW = Math.min(TextRender.maxCanvasWidth, w1 + margin * 2 * this.fontScaleX);
        if (needCanvW > this.charRender.canvasWidth) {
            this.charRender.canvasWidth = needCanvW;
        }
        if (isoTexture) {
            this.charRender.fontsz = font._size;
            imgdt = this.charRender.getCharBmp(str, this.fontStr, lineWidth, color, strokeColor, ri, margin, margin, margin, margin, null);
            if (imgdt) {
                var tex = TextTexture.getTextTexture(imgdt.width, imgdt.height);
                tex.addChar(imgdt, 0, 0, ri.uv);
                ri.texture = tex;
                ri.orix = margin;
                ri.oriy = margin;
                tex.ri = ri;
                this.isoTextures.push(tex);
            }
        }
        else {
            var len = str.length;
            if (len > 1) {
            }
            var lineExt = lineWidth * 1;
            var fw = Math.ceil((this.fontSizeW + lineExt * 2) * this.fontScaleX);
            var fh = Math.ceil((this.fontSizeH + lineExt * 2) * this.fontScaleY);
            TextRender.imgdtRect[0] = ((margin - this.fontSizeOffX - lineExt) * this.fontScaleX) | 0;
            TextRender.imgdtRect[1] = ((margin - this.fontSizeOffY - lineExt) * this.fontScaleY) | 0;
            if (this.renderPerChar || len == 1) {
                TextRender.imgdtRect[2] = Math.max(w1, fw);
                TextRender.imgdtRect[3] = Math.max(w1, fh);
            }
            else {
                TextRender.imgdtRect[2] = -(this.fontSizeOffX * this.fontScaleX);
                TextRender.imgdtRect[3] = fh;
            }
            this.charRender.fontsz = font._size;
            imgdt = this.charRender.getCharBmp(str, this.fontStr, lineWidth, color, strokeColor, ri, margin, margin, margin, margin, TextRender.imgdtRect);
            if (imgdt) {
                if (imgdt.width > TextRender.atlasWidth || imgdt.height > TextRender.atlasWidth) {
                    var tex = TextTexture.getTextTexture(imgdt.width, imgdt.height);
                    tex.addChar(imgdt, 0, 0, ri.uv);
                    ri.texture = tex;
                    ri.orix = margin;
                    ri.oriy = margin;
                    tex.ri = ri;
                    this.isoTextures.push(tex);
                }
                else {
                    atlas = this.addBmpData(imgdt, ri);
                    if (TextRender.isWan1Wan) {
                        ri.orix = margin;
                        ri.oriy = margin;
                    }
                    else {
                        ri.orix = (this.fontSizeOffX + lineExt);
                        ri.oriy = (this.fontSizeOffY + lineExt);
                    }
                    atlas.charMaps[key] = ri;
                }
            }
        }
        return ri;
    }
    addBmpData(data, ri) {
        var w = data.width;
        var h = data.height;
        var sz = this.textAtlases.length;
        var atlas;
        var find = false;
        for (var i = 0; i < sz; i++) {
            atlas = this.textAtlases[i];
            find = atlas.getAEmpty(w, h, tmpAtlasPos);
            if (find) {
                break;
            }
        }
        if (!find) {
            atlas = new TextAtlas();
            this.textAtlases.push(atlas);
            find = atlas.getAEmpty(w, h, tmpAtlasPos);
            if (!find) {
                throw 'err1';
            }
            this.cleanAtlases();
        }
        if (find) {
            atlas.texture.addChar(data, tmpAtlasPos.x, tmpAtlasPos.y, ri.uv);
            ri.texture = atlas.texture;
        }
        return atlas;
    }
    GC() {
        var i = 0;
        var sz = this.textAtlases.length;
        var dt = 0;
        var destroyDt = TextRender.destroyAtlasDt;
        var totalUsedRateAtlas = 0;
        var curloop = RenderInfo.loopCount;
        var maxWasteRateID = -1;
        var maxWasteRate = 0;
        var tex = null;
        var curatlas = null;
        for (; i < sz; i++) {
            curatlas = this.textAtlases[i];
            tex = curatlas.texture;
            if (tex) {
                totalUsedRateAtlas += tex.curUsedCovRateAtlas;
                var waste = curatlas.usedRate - tex.curUsedCovRateAtlas;
                if (maxWasteRate < waste) {
                    maxWasteRate = waste;
                    maxWasteRateID = i;
                }
            }
            dt = curloop - curatlas.texture.lastTouchTm;
            if (dt > destroyDt) {
                TextRender.showLog && console.log('TextRender GC delete atlas ' + tex ? curatlas.texture.id : 'unk');
                curatlas.destroy();
                this.textAtlases[i] = this.textAtlases[sz - 1];
                sz--;
                i--;
                maxWasteRateID = -1;
            }
        }
        this.textAtlases.length = sz;
        sz = this.isoTextures.length;
        for (i = 0; i < sz; i++) {
            tex = this.isoTextures[i];
            dt = curloop - tex.lastTouchTm;
            if (dt > TextRender.destroyUnusedTextureDt) {
                tex.ri.deleted = true;
                tex.ri.texture = null;
                tex.destroy();
                this.isoTextures[i] = this.isoTextures[sz - 1];
                sz--;
                i--;
            }
        }
        this.isoTextures.length = sz;
        var needGC = this.textAtlases.length > 1 && this.textAtlases.length - totalUsedRateAtlas >= 2;
        if (TextRender.atlasWidth * TextRender.atlasWidth * 4 * this.textAtlases.length > TextRender.cleanMem || needGC || TextRender.simClean) {
            TextRender.simClean = false;
            TextRender.showLog && console.log('清理使用率低的贴图。总使用率:', totalUsedRateAtlas, ':', this.textAtlases.length, '最差贴图:' + maxWasteRateID);
            if (maxWasteRateID >= 0) {
                curatlas = this.textAtlases[maxWasteRateID];
                curatlas.destroy();
                this.textAtlases[maxWasteRateID] = this.textAtlases[this.textAtlases.length - 1];
                this.textAtlases.length = this.textAtlases.length - 1;
                this.event('GC');
            }
        }
    }
    cleanAtlases() {
    }
}
TextRender.useOldCharBook = false;
TextRender.maxCanvasWidth = 4096;
TextRender.atlasWidth = 1024;
TextRender.noAtlas = false;
TextRender.forceSplitRender = false;
TextRender.forceWholeRender = false;
TextRender.scaleFontWithCtx = true;
TextRender.maxFontScale = 4;
TextRender.standardFontSize = 32;
TextRender.destroyAtlasDt = 10;
TextRender.checkCleanTextureDt = 2000;
TextRender.destroyUnusedTextureDt = 10;
TextRender.cleanMem = 100 * 1024 * 1024;
TextRender.isWan1Wan = false;
TextRender.showLog = false;
TextRender.debugUV = false;
TextRender.imgdtRect = [0, 0, 0, 0];
TextRender.simClean = false;
const tmpAtlasPos = new Point();
